import moment from 'moment'
import orderBy from 'lodash/orderBy'
import store from '@/store'
import i18n from '@/lang/index.js'
import { DATE_FORMATS } from '@/constants.js'

function createItemDisplay ({ depPort, arrPort, briefingId, flightNum, etd, deskId }) {
  const fallback = i18n.global.t('not-available')
  const depPortIata = store.getters.iataByIcao(depPort)
  const arrPortIata = store.getters.iataByIcao(arrPort)
  return {
    briefingId: briefingId,
    flightNum: flightNum,
    etd: etd
      ? moment(etd).format(DATE_FORMATS.DATETIME_SHORT)
      : fallback,
    route: `${depPort ?? fallback}—${arrPort ?? fallback}`,
    routeIata: `${depPortIata ?? fallback}—${arrPortIata ?? fallback}`,
    deskName: store.getters.deskNameById(deskId),
  }
}

export default {
  state: () => ({
    flights: []
  }),
  getters: {
    attentionFlights: state => {
      const items = state.flights.map(f => createItemDisplay(f))
      return orderBy(items, 'etd', 'asc')
    }
  },
  mutations: {
    replaceAttentionFlights (state, flights) {
      state.flights = Array.isArray(flights) ? flights : []
    },
    upsertAttentionFlight (state, flight) {
      if (!flight?.briefingId) {
        return
      }
      const index = state.flights.findIndex(f => f.briefingId === flight.briefingId)
      if (index === -1) {
        state.flights.push(flight)
        return
      }
      state.flights.splice(index, 1, flight)
    },
    removeAttentionFlight (state, briefingId) {
      if (!briefingId) {
        return
      }
      const index = state.flights.findIndex(f => f.briefingId === briefingId)
      if (index === -1) {
        return
      }
      state.flights.splice(index, 1)
    },
    clearAttentionFlights (state) {
      state.flights = []
    }
  }
}
